/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceSecretManagerCredentialsInfo } from './resourceSecretManagerCredentialsInfo';
import { ResourceProvider } from './resourceProvider';
import { ResourceAssignmentState } from './resourceAssignmentState';
import { ResourceState } from './resourceState';
import { ResourceType } from './resourceType';
import { ResourceCategory } from './resourceCategory';


export interface VcfOrgResourceInfo { 
    vcf_org_id?: string;
    provider?: ResourceProvider;
    resource_id?: string;
    state?: ResourceState;
    type?: ResourceType;
    assignment_state?: ResourceAssignmentState;
    category?: ResourceCategory;
    assigned_by?: string;
    assigned_time?: Date;
    managed?: boolean;
    metadata?: object;
    secret_manager_credentials?: Array<ResourceSecretManagerCredentialsInfo>;
}
export namespace VcfOrgResourceInfo {
}


